function injectRRPIntoSparkCards() {
  // Find a non-empty RRP element to use as height reference for spacers on empty cards.
  // These <p> tags are rendered by Shopify so they're available synchronously.
  const rrpRef = [...document.querySelectorAll('p[data-spark-rrp]')].find(p => p.textContent.trim());

  document.querySelectorAll('p[data-spark-rrp]').forEach(rrpTag => {
    const hasContent = !!rrpTag.textContent.trim();

    // Empty card with no reference on this page — nothing to align to, skip
    if (!hasContent && !rrpRef) return;

    const sparkCard = rrpTag.nextElementSibling;
    if (!sparkCard || sparkCard.tagName.toLowerCase() !== 'spark-product-card') return;

    // rrpWatching prevents duplicate per-card observers on repeated observer firings,
    // but does NOT block re-injection — that's checked against live DOM state below.
    if (sparkCard.dataset.rrpWatching) return;
    sparkCard.dataset.rrpWatching = 'true';

    function waitForShadowRoot() {
      if (!sparkCard.shadowRoot) {
        requestAnimationFrame(waitForShadowRoot);
        return;
      }
      watchShadowContent(sparkCard.shadowRoot);
    }

    function watchShadowContent(shadowRoot) {
      function tryInject() {
        // const priceWrapper = shadowRoot.querySelector('.product-price-wrapper');
        const priceWrapper = shadowRoot.querySelector('.sl-pricing-alignment');
        if (!priceWrapper) return;
        // Already injected — nothing to do
        if (priceWrapper.nextElementSibling?.hasAttribute('data-spark-rrp')) return;

        if (hasContent) {
          const clone = rrpTag.cloneNode(true);
          clone.style.removeProperty('display');
          priceWrapper.insertAdjacentElement('afterend', clone);
          rrpTag.style.display = 'none';
        } else {
          // Inject an invisible spacer so the price sits at the same height as RRP cards
          const spacer = rrpTag.cloneNode(true);
          spacer.style.removeProperty('display');
          spacer.style.visibility = 'hidden';
          spacer.style.pointerEvents = 'none';
          spacer.setAttribute('aria-hidden', 'true');
          priceWrapper.insertAdjacentElement('afterend', spacer);
          rrpTag.style.display = 'none';
        }
      }

      tryInject();

      // Keep observer alive so SparkLayer re-renders are caught
      new MutationObserver(tryInject).observe(shadowRoot, { childList: true, subtree: true });
    }

    waitForShadowRoot();
  });
}

// Called from sparkOptions.onReady so the observer only starts once SparkLayer
// is initialised. The initial call handles cards rendered in the same tick;
// the observer catches everything injected afterwards.
window.startSparkRRPObserver = function () {
  injectRRPIntoSparkCards();

  const observer = new MutationObserver(() => {
    injectRRPIntoSparkCards();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};
